import { TypePackageAddOnItemSkeleton } from "@contentful/types";
import { PaymentIntentResponse } from "@yardzen/rest-api-client";
import { Badge } from "@yardzen/ui/components/badge";
import { Checkbox } from "@yardzen/ui/components/checkbox";
import { H5 } from "@yardzen/ui/components/h5";
import { Label } from "@yardzen/ui/components/label";
import { Entry } from "contentful";

export function PackageDisplayAddOns({
  currentAddOns,
  paymentIntent,
  contentfulAddons,
  onToggleAddon,
  selectedAddonNames,
}: {
  currentAddOns: string[];
  paymentIntent: PaymentIntentResponse;
  contentfulAddons:
    | (
        | Entry<
            TypePackageAddOnItemSkeleton,
            "WITHOUT_UNRESOLVABLE_LINKS",
            string
          >
        | undefined
      )[]
    | undefined;
  onToggleAddon?: (stripeProductId: string, checked: boolean) => void;
  selectedAddonNames?: string[];
}) {
  const enrichedAddons = paymentIntent.addons?.map((addon) => {
    const contentfulAddon = contentfulAddons?.find(
      (cAddon) => cAddon?.fields.stripeProductName === addon?.name,
    );
    return {
      ...addon,
      contentful: contentfulAddon,
    };
  });

  return (
    <div className="bg-brand-beige-lighter rounded-lg p-6">
      {paymentIntent.addons && (
        <div>
          <H5 className="font-display mb-4 text-left text-2xl font-normal">
            Complete your plan
          </H5>
          {enrichedAddons?.map(
            (addonItem, i) =>
              addonItem && (
                <div
                  key={`PDI-addon-${addonItem.contentful?.fields.uniqueIdentifier}-${i}`}
                  className="items-top border-system-grayscale-30 mb-4 flex space-x-2 rounded-lg border border-dashed p-4"
                >
                  <Checkbox
                    id={`PDI-addon-checkbox-${addonItem.contentful?.fields.uniqueIdentifier}-${i}`}
                    className="mt-0.5"
                    checked={currentAddOns.includes(
                      addonItem.contentful?.fields.stripeProductId ?? "",
                    )}
                    onCheckedChange={(checked) => {
                      const stripeProductId =
                        addonItem.contentful?.fields.stripeProductId;
                      if (stripeProductId && onToggleAddon) {
                        onToggleAddon(stripeProductId, !!checked);
                      }
                    }}
                  />
                  <div className="grid gap-1.5 leading-none">
                    <Label
                      htmlFor={`PDI-addon-checkbox-${addonItem.contentful?.fields.uniqueIdentifier}-${i}`}
                      className="text-sm font-semibold"
                    >
                      {addonItem.contentful?.fields?.heading}
                      {addonItem?.price && (
                        <Badge
                          variant="secondary"
                          className="bg-brand-moss-greens-20 !font-display !text-xxs ml-2 !px-2 !py-0"
                        >
                          <span className="text-sm">
                            + ${addonItem?.price / 100}
                          </span>
                        </Badge>
                      )}
                    </Label>
                    <p className="text-brand-moss-greens-90 text-sm">
                      {addonItem.contentful?.fields?.subheading}
                    </p>
                  </div>
                </div>
              ),
          )}
        </div>
      )}
    </div>
  );
}
